import { UpsellItemsConfiguration } from '@app-types/eligibility/config';
import { FaiType } from '@app-types/plan';

import { isSameRangeAndPlay } from '@helpers/fai';

import { EligibilityOffer } from '@eligibility/helpers';

type OfferType = EligibilityOffer | FaiType;

export function getUpsellCombination<T extends OfferType>(
    offer: T,
    productsToUpsell: UpsellItemsConfiguration[],
): UpsellItemsConfiguration | undefined {
    return productsToUpsell.find((c) =>
        isSameRangeAndPlay(offer, c.baseProduct.rangeNg, c.baseProduct.commercialSeries, c.baseProduct.play),
    );
}

export function getUpsellOffer<T extends OfferType>(
    allOffers: T[],
    offer: T,
    productsToUpsell: UpsellItemsConfiguration[],
): T | undefined {
    const upsellCombination = getUpsellCombination(offer, productsToUpsell);
    const upselledProduct = upsellCombination?.upselledProduct;

    if (!upselledProduct) {
        return;
    }

    return allOffers?.find((o) =>
        isSameRangeAndPlay(o, upselledProduct.rangeNg, upselledProduct.commercialSeries, upselledProduct.play),
    );
}
